import { inject } from 'vue'
import type { DialogsGlobal } from '../components/interaction/dialog'
export const useDialogs = () => {
  const $dialogs = inject<DialogsGlobal>('$dialogs')
  if (!$dialogs) {
    throw new Error('Dialogs not found')
  }
  return { $dialogs }
}
